export const formatDate = (date: Date, format: string) => {
  let formatedDate: string = "";

  switch (format) {
    case "YYYY-MM-DD":
      formatedDate = date.getFullYear().toString() + "-";
      formatedDate += (date.getMonth() + 1).toString().padStart(2, "0") + "-";
      formatedDate += date.getDate().toString().padStart(2, "0");
      break;
    case "DD-MM-YYYY":
      formatedDate = date.getDate().toString().padStart(2, "0");
      formatedDate += (date.getMonth() + 1).toString().padStart(2, "0") + "-";
      formatedDate += date.getFullYear().toString() + "-";
      break;
    case "DD/MM/YYYY":
      formatedDate = date.getDate().toString().padStart(2, "0");
      formatedDate += (date.getMonth() + 1).toString().padStart(2, "0") + "/";
      formatedDate += date.getFullYear().toString() + "/";
      break;
    default:
      break;
  }

  return formatedDate;
};
